rdefine('app/events/modal',['backbone','text!events/modal.html'], function(Backbone, template) {

    var events = rrequire('app/events/events');
    var dates = new events([],{});

    var modal=new ModalWrapper({
        content:rrequire('app/events/Calendar'),
        title:window.LANGUAGE['events.modal.calendar.title'],
        config:{
            dates:dates
        }
    });


    return Backbone.Ribs.View.extend({
        "events":{
          "click .example-button":"onExampleButton"
        },
        initialize:function(modal) {
            this.$el.html(Template7.compile(template)({leftClass:'col-sm-3',rightClass:'col-sm-9'}));
        },
        onExampleButton: function() {
            modal.show();
        }
    });
});